import { render, staticRenderFns } from "./DataPrivacyComp.vue?vue&type=template&id=26f81991&scoped=true&"
import script from "./DataPrivacyComp.vue?vue&type=script&lang=ts&"
export * from "./DataPrivacyComp.vue?vue&type=script&lang=ts&"
import style0 from "./DataPrivacyComp.vue?vue&type=style&index=0&id=26f81991&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f81991",
  null
  
)

export default component.exports